module.exports = "<div>\r\n  <button class=\"btn btn-sm btn-ssn\" ngbTooltip=\"View\" (click)=\"viewItem();\">\r\n    <img height=\"16px\" src=\"assets/images/icons/128x128/white/eye.png\">\r\n  </button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/view-button/view-button.component.html
// module id = ./src/app/shared/components/view-button/view-button.component.html
// module chunks = main